module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body body-privacy"
  }, [_c('div', {
    staticClass: "container bg-privacy",
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-8 offset-md-2"
  }, [_c('h1', {
    staticClass: "font-weight-bolder"
  }, [_vm._v("Accessibility Policy")])])])]), _vm._v(" "), _c('div', {
    staticClass: "container bg-privacy"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-8 offset-md-2"
  }, [_c('p', [_vm._v("American Credit is committed to ensuring that individuals with disabilities can access all of the services, facilities, privileges, advantages, and accommodations offered by American Credit through its website, amcredit.com. We are actively working to increase the accessibility and usability of our website, and in doing so adhere to many of the available standards and guidelines to the greatest extent possible.")]), _vm._v(" "), _c('p', [_vm._v("If you are having trouble accessing amcredit.com please contact us or call 855-904-0188 for assistance.")])])]), _vm._v(" "), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-945aaf70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accessibilityPolicy.vue
// module id = 2009
// module chunks = 5